import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";

// Front
// import LayoutReducer from "./layouts/reducer";
import EcommerenceReducer from "./e-commerence/reducer";
import CryptoReducer from "./crypto/reducer";
import InvoiceReducer from "./invoices/reducer";
import ProjectsReducer from "./projects/reducer";
import TasksReducer from "./tasks/reducer";
import ContactsReducer from "./contacts/reducer"
import DashboardReducer from "./dashboards/reducer";
import JobsReducer from "./jobs/reducer";
import ChatsReducer from "./chats/reducer";
import CalendarReducer from "./calendar/reducer";
import LayoutReducer from "./layouts/reducer";
import EmailReducer from "./email/reducer";
import LoginReducer from "./auth/login/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgotPasswordReducer from "./auth/forgetpwd/reducer";
import AccountReducer from "./auth/register/reducer";
import PageChangeReducer from "../features/reducers/DocumentScan/PageChange.Reducer";
import RequotePageChangeReducer from "../features/reducers/Reqoute/RequotePageChange.Reducer";
import FilterDataReducers from "../features/reducers/filterdata/FilterData.Reducers";
import FindDeviceReducers from "../features/reducers/finddevice/FindDevice.Reducers";
import OtpReducers from "../features/reducers/otp/Otp.Reducers";
import UserNameReducers from "../features/reducers/username/UserName.Reducers";
import ResetPageChangeReducer from "../features/reducers/DocumentScan/PageChange.Reducer";
import OrderSummaryInfoReducer from "../features/reducers/ordersummary/OrderSummaryInfo.Reducers";
import RepairRequoteInfoReducer from '../features//reducers/RepairRequote/RepairRequoteSummary.Reducers';
import DashboardFilterReducers from "features/reducers/filterdata/DashboardFilter.Reducers";

const rootReducer = combineReducers({
    Layout: LayoutReducer,
    ecommerce: EcommerenceReducer,
    crypto: CryptoReducer,
    invoices: InvoiceReducer,
    projects: ProjectsReducer,
    tasks: TasksReducer,
    contacts: ContactsReducer,
    dashboard: DashboardReducer,
    jobs: JobsReducer,
    chats: ChatsReducer,
    calendar: CalendarReducer,
    email: EmailReducer,
    Login: LoginReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgotPasswordReducer,
    Account: AccountReducer,
    PageChangeReducer: PageChangeReducer,
    resetPageReducer: ResetPageChangeReducer,
    RequotePageChangeReducer: RequotePageChangeReducer,
    OtpReducers: OtpReducers,
    UserNameReducers: UserNameReducers,
    OrderSummaryInfoReducer: OrderSummaryInfoReducer,
    RepairRequoteInfoReducer: RepairRequoteInfoReducer,
    FindDevice: FindDeviceReducers,
    FilterDataReducers: FilterDataReducers,
    DashboardFilterReducers: DashboardFilterReducers
});


export default rootReducer;